import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import PsychologyIcon from '@mui/icons-material/Psychology';
import SchoolIcon from '@mui/icons-material/School';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import * as React from 'react'

export default { MedicalInformationIcon, PsychologyIcon, SchoolIcon, LocalHospitalIcon, FamilyRestroomIcon, React }